import { render, staticRenderFns } from "./PuAlert.vue?vue&type=template&id=67484763&scoped=true&"
import script from "./PuAlert.vue?vue&type=script&lang=js&"
export * from "./PuAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67484763",
  null
  
)

export default component.exports